import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import { Button, Modal, ModalContent, ModalFooter, ModalHeader, ModalTitle, Text } from '@nike/podium';
import { useEffect } from 'react';
export default function ConfirmationModal({ isOpen, setModalOpen, modalText = 'Are you sure?', buttonText = 'Yes', action }) {
    useEffect(() => {
        const handleEscape = (event) => {
            if (event.key === 'Escape' && isOpen) {
                setModalOpen(false);
            }
        };
        if (isOpen) {
            document.addEventListener('keydown', handleEscape);
        }
        return () => {
            document.removeEventListener('keydown', handleEscape);
        };
    }, [isOpen, setModalOpen]);
    const handleConfirm = () => {
        setModalOpen(false);
        action().catch((error) => {
            console.error('Error in action:', error);
        });
    };
    const handleCancel = () => {
        setModalOpen(false);
    };
    const handleOpenChange = (open) => {
        setModalOpen(open);
    };
    return (_jsx(Modal, { open: isOpen, onOpenChange: handleOpenChange, children: _jsx(ModalContent, { className: "min-w-[40%]", "data-testid": "delete-confirmation-modal", children: _jsxs("div", { className: "p-4 flex flex-col", children: [_jsx(ModalHeader, { children: _jsxs(ModalTitle, { children: ["Confirm ", buttonText] }) }), _jsx("div", { className: "flex-1", children: _jsx(Text, { children: modalText }) }), _jsxs(ModalFooter, { className: "flex justify-start gap-2", children: [_jsx(Button, { onClick: handleCancel, className: "!bg-gray-200 hover:!bg-gray-300 !text-black", "data-testid": "cancel-button", children: "Cancel" }), _jsx(Button, { onClick: handleConfirm, "data-testid": "confirm-button", children: buttonText })] })] }) }) }));
}
